import moment from "moment";

function GeneratedEmailLogs({ patient, id = "", className = "" }) {
    return (
        <>
            <div className={className} id={id}>
                <h5>
                    GENERATED EMAIL
                </h5>
                {
                    patient?.generatedEmails?.length > 0
                        ? <table>
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Date Created</th>
                                    <th>Filtered</th>
                                    <th>Original Email ID</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    patient?.generatedEmails?.map((ge, i2) => {
                                        return (
                                            <tr>
                                                <td>{ge?.id}</td>
                                                <td>{ge?.created_at ? moment(ge?.created_at).format("lll") : "-"}</td>
                                                <td>{ge?.filtered == 1 ? "true" : "false"}</td>
                                                <td>{ge?.oldEmail}</td>
                                            </tr>
                                        )
                                    })
                                }
                            </tbody>
                        </table>
                        : <div>
                            -- NONE --
                        </div>
                }
            </div>
        </>
    );
}

export default GeneratedEmailLogs;